import React, { useState } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, setDoc } from "firebase/firestore";
import './LoginPage.css';

const LoginPage = () => {
    const [isRegisterActive, setIsRegisterActive] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (err) {
            setError(err.message);
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const cred = await createUserWithEmailAndPassword(auth, email, password);
            const userDocRef = doc(db, 'users', cred.user.uid);
            await setDoc(userDocRef, { 
              email: email 
            });
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="login-page-container">
            <div className={`wrapper ${isRegisterActive ? 'active' : ''}`}>
                <div className="form-box login">
                    <h2>Login</h2>
                    {error && !isRegisterActive && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
                    <form onSubmit={handleLogin}>
                        <div className="input-box">
                            <span className="icon"><ion-icon name="mail"></ion-icon></span>
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                            <label>Email</label>
                        </div>
                        <div className="input-box">
                            <span className="icon"><ion-icon name="lock-closed"></ion-icon></span>
                            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                            <label>Password</label>
                        </div>
                        <div className="remember-forgot">
                            <label><input type="checkbox" />Remember me</label>
                            <button type="button" className="link-button" onClick={() => alert('Forgot password functionality not implemented yet.')}>Forgot Password?</button>
                        </div>
                        <button type="submit" className="btn">Login</button>
                        <div className="login-register">
                            <p>Don't have an account? <button type="button" className="link-button register-link" onClick={() => { setIsRegisterActive(true); setError(''); }}>Register</button></p>
                        </div>
                    </form>
                </div>

                <div className="form-box register">
                    <h2>Registration</h2>
                    {error && isRegisterActive && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
                    <form onSubmit={handleRegister}>
                        <div className="input-box">
                            <span className="icon"><ion-icon name="mail"></ion-icon></span>
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                            <label>Email</label>
                        </div>
                        <div className="input-box">
                            <span className="icon"><ion-icon name="lock-closed"></ion-icon></span>
                            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                            <label>Password</label>
                        </div>
                        <div className="remember-forgot">
                            <label><input type="checkbox" />I agree to the terms & conditions</label>
                        </div>
                        <button type="submit" className="btn">Register</button>
                        <div className="login-register">
                            <p>Already have an account? <button type="button" className="link-button login-link" onClick={() => { setIsRegisterActive(false); setError(''); }}>Login</button></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;